import React from 'react';
import { Helmet } from 'react-helmet';
import SubHeader from 'components/SubHeader';
import { useParams } from 'react-router-dom';
import Button from 'components/Button';
import {
  Content,
  ContentColumn,
  Container
} from 'components/BookingMain/styles';
import PicturesWall from './components/PicturesWall';

const RoomTypeDetails = () => {
  
  const roomTypeId = useParams().roomTypeId;

  //FIXME: Replace with actual data
  const loading=false
  const handleSaveChanges = () => {
    if(loading) return;
    //TODO: Handle save changes logic here
  };

  return (
    <>
      <Helmet>
        <title>Room Type Details - Rook Hotel PMS</title>
        <meta name="description" content="Room Type Details - Rook Hotel PMS" />
      </Helmet>
      <SubHeader>
        <div className='title'>
          Room Type Details
        </div>
        <div className='buttonContainer'>
          <div>
            <Button
              mainPage
              success
              onClick={handleSaveChanges}
              data-loading={loading}
              additionalstyle={`
                width: 122px;
                margin-left: 14px;

                @media only screen and (min-width: 767px) and (max-width: 1200px) {
                  width: 141px;
                }
  
                @media only screen and (max-width: 767px) {
                  width: 110px;
                }
              `}
            >
              {loading? null: 'Save Changes'}
            </Button>
          </div>
        </div>
      </SubHeader>
      <Content
        additionalstyle={`
          margin-top: 100px;
        `}
      >
        <ContentColumn>
          <Container>
            <PicturesWall />
          </Container>
        </ContentColumn>
        <ContentColumn>
          <Container>
          </Container>
        </ContentColumn>
      </Content>
    </>
  );
};

export default RoomTypeDetails;
